import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { IncomePaymentOneOffStatic } from "./IncomePaymentOneOffStatic";


export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
}

export const IncomePaymentOneOffDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const IncomePaymentOneOffStore: IncomePaymentOneOffStatic = new IncomePaymentOneOffStatic();

